import './index.css'
import './App.css';

import { Routes, Route, BrowserRouter } from "react-router-dom";
import Header from './Components/Header/Header';
import Strategy from './Components/Stategy/Strategy';
import Footer from './Components/Footer/Footer';
import About from './Components/About/About';
import News from './Components/News/News';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

function Home() {
  return (
    <>
      
      <div className="App">
        <Header />
        <Strategy />
        <Footer />
      </div>
    </>

  );
}

function AboutPage() {
  return (
    <>
      
      <div className="App">
        <Header />
        <About />
        <Footer />
      </div>
    </>

  );
}

function NewsPage() {

  return (
    <>
      
      <div className="App">
        <Header />
        <News />
        <Footer />
      </div>
    </>

  );
}
